import { ListViewProvider } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'
import Certificate from './Certificate'
import DatePicker from 'react-datepicker'
import { useEffect, useState } from 'react'
import { useAuth } from '../../../../auth'
import DownloadPDFButton from '../table/columns/DownloadPDFButton'

const initialState = {
  date: '',
  facility: '',
}
const QualityList = () => {
  const [userSelectedData, setUserSelectedData] = useState<any>(initialState)
  const [searchResult, setSearchResult] = useState(false)
  const dateFormated = userSelectedData?.date?.split('T') || ''
  const newFormatedDate = dateFormated?.[0]?.split('-')
  const connectedData = +newFormatedDate[1] + '/' + newFormatedDate?.[0]
  const { isFacilityManager, auth }: any = useAuth()







  const getMonthDateRange = (dateString) => {
    if (!dateString) return { startDate: '', endDate: '' }

    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = date.getMonth()

    const firstDay = new Date(year, month, 1)
    const lastDay = new Date(year, month + 1, 0)

    const formatDate = (date) => {
      const mm = String(date.getMonth() + 1).padStart(2, '0')
      const dd = String(date.getDate()).padStart(2, '0')
      const yyyy = date.getFullYear() // Full year
      return `${mm}%2F${dd}%2F${yyyy}` // mm/dd/yyyy format
    }

    return {
      startDate: formatDate(firstDay),
      endDate: formatDate(lastDay)
    }
  }


  const { startDate, endDate } = getMonthDateRange(userSelectedData.date)

  const { responseData: sankeyData } = useFetchCommon({
    api: `sankey/production/p2p/${userSelectedData.facility}/2025?start_date=${startDate}&end_date=${endDate}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: Boolean(searchResult),
  })






  const { responseData: facilityTypeList } = useFetchCommon({
    // api: 'users?page=0&size=10&type=PICKUP_POINT',
    api: 'users?type=PICKUP_POINT&facilityType=COLLECTION_TYPE%2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY',
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: !isFacilityManager,
  })
  const [facilityDropdown, setFacilityDropdown] = useState([])

  useEffect(() => {
    if (facilityTypeList.length) {
      setFacilityDropdown(
        facilityTypeList.map((x) => ({ label: x?.personalDetails?.name ?? '', value: x.id }))
      )
    }
  }, [facilityTypeList])

  // console.log(
  //   facilityTypeList,
  //   'facilityTypeListfacilityTypeList',
  //   userSelectedData.facility,
  //   facilityTypeList.filter((x) => x.id === userSelectedData?.facility)?.[0]?.franchiseId
  // )
  const { responseData: supplierData } = useFetchCommon({
    api: `supplierReport/${userSelectedData.facility}?month=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
    franchiseId: facilityTypeList.filter((x) => x.id === userSelectedData?.facility)?.[0]
      ?.franchiseId,
  })
  /* FOR THE API */
  const { responseData: analyticsMonth } = useFetchCommon({
    api: `admin/pickupPoints/analytics/${userSelectedData.facility}?month=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
    franchiseId: facilityTypeList.filter((x) => x.id === userSelectedData?.facility)?.[0]
      ?.franchiseId,
  })
  const { responseData: inventory } = useFetchCommon({
    api: `admin/pickupPoints/${userSelectedData.facility}/inventory?month=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })
  const { responseData: analytics } = useFetchCommon({
    api: `analytics/${userSelectedData.facility}?month=${connectedData}`,
    label: ['personalDetails', 'name'],
    isDropDown: false,
    isEnabled: searchResult,
  })

  const handleChange = (name, value) => {
    setSearchResult(false)
    setUserSelectedData({ ...userSelectedData, [name]: value })
  }

  // console.log({analyticsMonth, inventory, analytics})
  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear()
    const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`

    return <span title={tooltipText}>{shortMonth}</span>
  }

  /* 
  download/pickupPoints/{pickupPointId}?month=02/2025
  
  */
  const url =
    process.env.REACT_APP_BASE_API_URL +
    `download/pickupPoints/${userSelectedData.facility}}?month=${connectedData}`
  return (
    <>

      <div className="card mb-3">
        <div className="card-body">
          <div className={`grid grid-cols-4 gap-3 my-2`}>
            <>
              <div className=''>
                <label className='form-label fs-6 fw-bold'>Select Material Hub</label>
                <select
                  style={{
                    backgroundColor: '#ffffff',
                    border: '1px solid #dddddd',
                    color: '#000000', // Text color for selected option
                  }}
                  className='form-select form-select-solid'
                  data-kt-select2='true'
                  data-placeholder='Select option'
                  data-allow-clear='true'
                  onChange={(e) => handleChange('facility', e.target.value)}
                  value={userSelectedData.facility || ''}
                >
                  {[
                    { value: '', label: 'Select one' },
                    ...(isFacilityManager
                      ? [{ value: auth?.data?.pickuppointid, label: auth?.data?.pickuppointName }]
                      : facilityDropdown),
                  ].map((eachOption, eachInd) => (
                    <option key={eachInd + 1 + ''} value={eachOption.value}>
                      {eachOption.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className='form-label fs-6 fw-bold'>Month</label>
                <br />
                <DatePicker
                  // dateFormat='MM/yyyy'
                  customInput={
                    <input
                      style={{
                        backgroundColor: '#ffffff',
                        border: '1px solid #dddddd',
                        color: '#000000',
                      }}
                    />
                  }
                  placeholderText={`Select Month`}
                  className='form-control form-control-solid w-250px ps-14'
                  showMonthYearPicker
                  showFullMonthYearPicker
                  showFourColumnMonthYearPicker
                  show
                  selected={userSelectedData.date || null}
                  // onChange={(date) => handleChange('date', new Date(date))}
                  onChange={(date) => {
                    // Normalize to midnight local time
                    const normalizedDate = new Date(date.getFullYear(), date.getMonth(), 1)

                    // Convert to ISO 8601 format in UTC
                    const utcDate = new Date(
                      Date.UTC(
                        normalizedDate.getFullYear(),
                        normalizedDate.getMonth(),
                        normalizedDate.getDate()
                      )
                    )
                    handleChange('date', utcDate.toISOString())
                  }}
                />{' '}
              </div>
              <div
                className='flex'
                style={{
                  marginTop: '27px',
                }}
              >
                <button
                  type='button'
                  // style={{ backgroundColor: '#ED6E43' }}
                  onClick={() => setSearchResult(true)}
                  className='btn btn-primary fw-bold px-6'
                  data-kt-menu-dismiss='true'
                  data-kt-user-table-filter='filter'
                  disabled={!userSelectedData.date || !userSelectedData.facility}
                >
                  Apply
                </button>
                &nbsp;
                {/* <button
              type='button'
              style={{backgroundColor: '#333333'}}
              // onClick={handleExport}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
              // disabled
              // disabled={dataToRender && dataToRender.length === 0}
            >
              Download
            </button> */}
                <DownloadPDFButton
                  windowPrint={true}
                  disable={!userSelectedData.facility && !userSelectedData?.date}
                  className='btn btn-primary fw-bold px-6'
                  url={url}
                />
              </div>
            </>
          </div>
        </div>
      </div>


      {
        /* Object.keys(inventory).length > 0 && */ <Certificate
          inventory={inventory}
          graphData={analytics}
          supplierData={supplierData}
          analyticsMonth={analyticsMonth?.[0] || {}}
          month={connectedData || ''}
          sankeyData={sankeyData} // Add this line
        />
      }
    </>
  )
}

const MonthlyReportWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <QualityList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { MonthlyReportWrapper }
